import React from 'react';
import { UsersProvider } from '../../../contexts/UsersContext';
import Users from './Users';

export default (props) => {
    return (
        <UsersProvider>
            <Users />
        </UsersProvider>
    );
};